export default __webpack_public_path__ + "static/media/pinkArrow.9f51c2ed.png";